import React from 'react';
import { Menu, Item, Separator } from 'react-contexify';
import { Icon } from '../_components';
import { useModal } from '../_contexts';

export function EventMenu() {
  const { openModal } = useModal();

  // const handleCopy = (event) => {
  //   // const { props } = event;
  //   const { eventItem } = event.props;
  //   console.log('Copied Item', eventItem);
  // };

  const handleDelete = (event) => {
    const { eventItem } = event.props;
    // console.log('Deleted Item', eventItem);
    openModal('confirmDelete', { type: 'event', item: eventItem });
  };

  const handleEdit = (event) => {
    const { eventItem } = event.props;
    // console.log('Launched Editor', eventItem);
    openModal('newEvent', { eventItem });
  };

  const handleCreate = (event) => {
    // console.log('CREATE Event', event);
    const { newEventItem } = event.props;
    // console.log('Launched Editor', newEventItem);
    openModal('newEvent', { eventItem: newEventItem });
  };

  return (
    <Menu
      id="chronos-event-context-menu"
      className="chronos-context-menu chronos-context-menu-event"
    >
      <Item onClick={handleEdit}>
        <Icon icon="fas fa-edit fa-fw" />
        &nbsp; Edit
      </Item>
      {/* <Item onClick={handleCopy}>
        <Icon icon="fas fa-copy fa-fw" />
        &nbsp; Copy
      </Item> */}
      <Separator />
      <Item onClick={handleDelete}>
        <Icon icon="fas fa-trash fa-fw" />
        &nbsp; Delete
      </Item>
      <Separator />
      <Item onClick={handleCreate}>
        <Icon icon="fas fa-plus fa-fw" />
        &nbsp; Create Event
      </Item>
    </Menu>
  );
}
